/* @ngInject */
function TaskStatusCardController (
  $translate,
  $scope,
  $rootScope,
  $q,
  ModalService,
  TasksService,
  SegmentService,
  UdsModalService,
  ToastService
) {
  const getNewTaskDialogController = () => $q.when(import('../../dialogs/new-task/new-task-dialog.controller'))
  const getRejectRequestDialogController = () =>
    $q.when(import('../../dialogs/reject-request/reject-request-dialog.controller'))
  const getRequestApprovalDialogController = () =>
    $q.when(import('../../dialogs/request-approval/request-approval-dialog.controller'))
  const getRequestFormDialogController = () =>
    $q.when(import('../../dialogs/request-form/request-form-dialog.controller'))
  const getAcceptRequestDialogController = () =>
    $q.when(import('../../dialogs/accept-request/accept-request-dialog.controller'))
  const getRequestAdjustmentDialogController = () =>
    $q.when(import('../../dialogs/request-adjustment/request-adjustment-dialog.controller'))
  const getCreateTaskDialogController = () =>
    $q.when(import('../../dialogs/create-task/create-task-dialog.controller'))

  var ctrl = this
  let oldModalReference

  ctrl.statusTitle = ''
  ctrl.statusDescription = ''

  const api = {
    getNewTaskDialogController,
    getRejectRequestDialogController,
    getRequestApprovalDialogController,
    getRequestFormDialogController,
    getAcceptRequestDialogController,
    getRequestAdjustmentDialogController,
    getCreateTaskDialogController,
    _openDialog,
    _openCreateTaskDialog,
    _openNewTaskDialog
  }

  this.getApi = () => api

  activate()

  function activate () {}

  ctrl.shouldShowEditRequestButton = function () {
    if (!ctrl.task) return false

    const shouldShowButtonToGroupOwner = ctrl.task.lastStatus === 'WAITING_RESPONSE'
    const taskIsWaitingUserAdjust = ctrl.task.status === 'WAITING_USER_ADJUST'
    const loggedUserIsAdminDesigner = $rootScope.isUserSysAdminAdminDesigner()
    const loggedUserIsGroupOwner = !!$rootScope.oUser?.isGroupOwner
    const taskIsArchived = ctrl.task.isArchived

    if (taskIsArchived) return false
    if (!taskIsWaitingUserAdjust) return false

    if (shouldShowButtonToGroupOwner && loggedUserIsGroupOwner) return true
    if (!loggedUserIsAdminDesigner && !loggedUserIsGroupOwner) return true

    return false
  }

  ctrl.shouldShowRequestApprovalButton = function () {
    if (!ctrl.task) return false

    const shouldShowButtonToGroupOwner = ctrl.task.lastStatus === 'WAITING_RESPONSE'
    const taskIsWaitingUserAdjust = ctrl.task.status === 'WAITING_USER_ADJUST'
    const taskIsWaitingAdminAdjust = ctrl.task.status === 'WAITING_ADM_ADJUST'
    const loggedUserIsAdminDesigner = $rootScope.isUserSysAdminAdminDesigner()
    const loggedUserIsGroupOwner = !!$rootScope.oUser?.isGroupOwner
    const taskIsArchived = ctrl.task.isArchived

    if (taskIsArchived) return false

    if (taskIsWaitingUserAdjust && shouldShowButtonToGroupOwner && loggedUserIsGroupOwner) return true
    if (taskIsWaitingUserAdjust && !loggedUserIsAdminDesigner && !loggedUserIsGroupOwner) return true
    if (taskIsWaitingAdminAdjust && loggedUserIsAdminDesigner && $rootScope.oUser.id !== ctrl.task.authorId) return true

    return false
  }

  ctrl.shouldShowRejectButton = function () {
    if (!ctrl.task) return false

    const userIsGroupOwner = !!$rootScope.oUser?.isGroupOwner
    const userIsAdminDesigner = $rootScope.isUserSysAdminAdminDesigner()
    const isArchived = ctrl.task.isArchived

    if (isArchived) return false

    if (userIsAdminDesigner && ctrl.task.status === 'WAITING_RESPONSE') return true
    if (userIsGroupOwner && ctrl.task.status === 'WAITING_PRE_APPROVAL') return true

    return false
  }

  ctrl.shouldShowRequestAdjustsButton = function () {
    if (!ctrl.task) return false

    const isRejected = ctrl.task.status === 'REJECTED'
    const isWaitingResponse = ctrl.task.status === 'WAITING_RESPONSE'
    const isReview = ctrl.task.status === 'REVIEW'
    const isWaitingPreApproval = ctrl.task.status === 'WAITING_PRE_APPROVAL'
    const isAdminDesigner = $rootScope.isUserSysAdminAdminDesigner()
    const loggedUserIsTaskAuthor = $rootScope.oUser.id === ctrl.task.authorId
    const loggedUserIsGroupOwner = !!$rootScope.oUser?.isGroupOwner
    const taskIsArchived = ctrl.task.isArchived

    if (taskIsArchived) return false

    if (isWaitingPreApproval && loggedUserIsGroupOwner) return true
    if (isRejected && (isAdminDesigner || loggedUserIsGroupOwner)) return true
    if (isWaitingResponse && isAdminDesigner) return true
    if (isReview && (!isAdminDesigner || loggedUserIsTaskAuthor)) return true

    return false
  }

  ctrl.shouldShowApproveButton = function () {
    if (!ctrl.task) return false

    const taskIsRejected = ctrl.task.status === 'REJECTED'
    const taskIsWaitingResponse = ctrl.task.status === 'WAITING_RESPONSE'
    const taskIsWaitingPreApproval = ctrl.task.status === 'WAITING_PRE_APPROVAL'
    const loggedUserIsAdminDesigner = $rootScope.isUserSysAdminAdminDesigner()
    const isArchived = ctrl.task.isArchived
    const loggedUserIsGroupOwner = !!$rootScope.oUser?.isGroupOwner

    if (isArchived) return false

    if (taskIsRejected && (loggedUserIsAdminDesigner || loggedUserIsGroupOwner)) return true
    if (taskIsWaitingResponse && loggedUserIsAdminDesigner) return true
    if (taskIsWaitingPreApproval && loggedUserIsGroupOwner) return true

    return false
  }

  ctrl.defineStatus = function (status, isArchived) {
    ctrl.statusTitle = ''
    ctrl.statusDescription = ''
    ctrl.isAdminDesigner = $rootScope.isUserSysAdminAdminDesigner()

    switch (true) {
      case status === 'WAITING_PRE_APPROVAL' && !isArchived && !!$rootScope.oUser?.isGroupOwner:
        ctrl.statusTitle = $translate.instant('waitingApproval')
        ctrl.statusDescription = $translate.instant('waitingApprovalDescription')
        return 'waiting-response'
      case (status === 'WAITING_RESPONSE' || (status === 'WAITING_PRE_APPROVAL' && !$rootScope.oUser?.isGroupOwner)) && !isArchived:
        ctrl.statusTitle = $translate.instant('waitingApproval')
        if (ctrl.isAdminDesigner) {
          ctrl.statusDescription = $translate.instant('waitingApprovalDescription')
        } else {
          ctrl.statusDescription = $translate.instant('waitingResponseDescription')
        }
        return 'waiting-response'
      case status === 'WAITING_ADM_ADJUST' && !isArchived:
        if (ctrl.isAdminDesigner && $rootScope.oUser.id !== ctrl.task.authorId) {
          ctrl.statusTitle = $translate.instant('waitingApproval')
          ctrl.statusDescription = $translate.instant('waitingUserAdjustsUser')
        } else {
          ctrl.statusTitle = $translate.instant('waitingAdjusts')
          ctrl.statusDescription = $translate.instant('waitingUserAdjustsAdmin')
        }
        return 'adjustments'
      case status === 'WAITING_USER_ADJUST' && !isArchived:
        ctrl.statusTitle = $translate.instant('waitingAdjusts')
        if (ctrl.isAdminDesigner || ($rootScope?.oUser?.isGroupOwner && ctrl.task.lastStatus !== 'WAITING_RESPONSE')) {
          ctrl.statusDescription = $translate.instant('waitingUserAdjustsAdmin')
        } else {
          ctrl.statusDescription = $translate.instant('waitingUserAdjustsUser')
        }
        return 'adjustments'
      case status === 'REVIEW' && !isArchived:
        if (ctrl.isAdminDesigner && $rootScope.oUser.id !== ctrl.task.authorId) {
          ctrl.statusTitle = $translate.instant('waitingReview')
          ctrl.statusDescription = $translate.instant('waitingReviewAdmin')
        } else {
          ctrl.statusTitle = $translate.instant('waitingReview')
          ctrl.statusDescription = $translate.instant('waitingReviewDescription')
        }
        return 'review'
      case status === 'PROGRESS' && !isArchived:
        if (!ctrl.isAdminDesigner) {
          ctrl.statusTitle = $translate.instant('taskInProgress')
          ctrl.statusDescription = $translate.instant('inProgressDescription')
          return 'in-progress'
        }
        break
      case status === 'INBOX' && !isArchived:
        if (!ctrl.isAdminDesigner) {
          ctrl.statusTitle = $translate.instant('taskInInbox')
          ctrl.statusDescription = $translate.instant('taskInInboxDescription')
          return 'in-progress'
        }
        break
      case status === 'DONE' && !isArchived:
        if (!ctrl.isAdminDesigner) {
          ctrl.statusTitle = $translate.instant('taskDone')
          ctrl.statusDescription = $translate.instant('taskDoneDescription')
          return 'done'
        }
        break
      case status === 'REJECTED' && !isArchived:
        if (ctrl.isAdminDesigner || !!$rootScope.oUser?.isGroupOwner) {
          ctrl.statusTitle = $translate.instant('taskRejected')
          ctrl.statusDescription = $translate.instant('taskRejectedDescription')
        }
        return 'task-rejected'
      case isArchived:
        ctrl.statusTitle = $translate.instant('taskArchived')
        if (ctrl.isAdminDesigner) {
          ctrl.statusDescription = $translate.instant('taskArchivedDescriptionAdmin')
        } else {
          ctrl.statusDescription = $translate.instant('taskArchivedDescriptionUser')
        }
        return 'archived'
    }
  }

  ctrl.openRequestApprovalDialog = function () {
    api.getRequestApprovalDialogController().then(({ RequestApprovalDialogController }) => {
      const templateId = 'requestApproval.html'
      const templateUrl = '/workflow/dialogs/request-approval/request-approval-dialog.html?$$REVISION$$'
      const controller = RequestApprovalDialogController

      api._openDialog(templateId, templateUrl, controller)
    })
  }

  ctrl.openRejectRequestDialog = function () {
    api.getRejectRequestDialogController().then(({ RejectRequestDialogController }) => {
      const rejectRequestDialog = UdsModalService.createModal({
        controller: RejectRequestDialogController,
        modalName: 'rejectRequestDialog',
        data: {
          taskId: ctrl.task.id
        },
        onClose: statusChanged => {
          if (statusChanged) {
            $scope.$emit('task-status-changed', true)
          }
        }
      })

      rejectRequestDialog.open()
    })
  }

  $scope.openAcceptRequestDialog = function (taskId) {
    getAcceptRequestDialogController().then(({ AcceptRequestDialogController }) => {
      const acceptRequestDialog = UdsModalService.createModal({
        controller: AcceptRequestDialogController,
        modalName: 'acceptRequestDialog',
        data: {
          taskId: taskId,
          task: ctrl.task
        }
      })

      acceptRequestDialog.open()
    })
  }

  $scope.openRequestAdjustDialog = function () {
    getRequestAdjustmentDialogController().then(({ RequestAdjustmentDialogController }) => {
      const requestAdjustmentDialog = UdsModalService.createModal({
        controller: RequestAdjustmentDialogController,
        modalName: 'requestAdjustmentDialog',
        data: {
          task: ctrl.task
        }
      })

      requestAdjustmentDialog.open()
    })
  }

  ctrl.openNewTaskDialog = function () {
    $rootScope.getUser().then(user => {
      if (user?.isGroupOwner) {
        return TasksService.updateTaskStatus(ctrl.task.id, {
          status: 'WAITING_RESPONSE',
          message: '',
          reaction: '',
          boardId: null
        }).then(() => {
          ToastService.showSuccessToast($translate.instant('taskApprovedByGroupOwner'))
        }).finally(() => {
          $scope.$emit('task-status-changed', true)

          SegmentService.track('approved-task', { type: 'TASK', task_id: ctrl.task.id })
        })
      }

      api._openCreateTaskDialog()
    })
  }

  ctrl.openEditRequestDialog = function () {
    api.getRequestFormDialogController().then(({ RequestFormDialogController }) => {
      const templateId = 'requestForm.html'
      const templateUrl = '/workflow/dialogs/request-form/request-form-dialog.html?$$REVISION$$'
      const controller = RequestFormDialogController

      api._openDialog(templateId, templateUrl, controller)
    })
  }

  ctrl.finishTask = function (taskId) {
    TasksService.updateTaskStatus(taskId, { status: 'DONE' }).then(() => {
      $scope.$emit('task-status-changed', true)
      SegmentService.track('finished-task', {
        type: ctrl.task.originType,
        task_id: taskId,
        briefing_id: ctrl.task.briefingId
      })
    })
  }

  ctrl.unarchiveTask = function (taskId, originType) {
    TasksService.updateTaskFields(taskId, { isArchived: false }).then(() => {
      $scope.$emit('task-status-changed', true)
      $scope.$emit('task-unarchived', taskId)
      SegmentService.track('unarchived-task', { task_id: taskId, type: originType })
    })
  }

  function _openDialog (templateId, templateUrl, controller, approve) {
    oldModalReference = ModalService.getCurrentModal()

    const data = {
      task: ctrl.task,
      taskId: ctrl.task.id,
      briefingId: ctrl.task.briefingId,
      originType: ctrl.task.originType,
      authorId: ctrl.task.authorId
    }

    if (approve) {
      data.approve = true
    }

    ModalService.showModal({
      templateId,
      templateUrl,
      destroyable: true,
      observeChanges: true,
      allowMultiple: true,
      appendElement: $('.request-details-dialog'),
      controller,
      data
    }).then(statusChanged => {
      if (oldModalReference) {
        ModalService.setCurrentModal(oldModalReference)
        ModalService.showCurrentModal()
      }
      if (statusChanged) {
        $scope.$emit('task-status-changed', true)
      }
    })
  }

  function _openCreateTaskDialog () {
    api.getCreateTaskDialogController().then(({ CreateTaskDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: CreateTaskDialogController,
        modalName: 'createTaskDialogDirective',
        data: {
          approve: true,
          taskId: ctrl.task.id,
          briefingId: ctrl.task.briefingId
        },
        onClose: statusChanged => {
          if (statusChanged) {
            $scope.$emit('task-status-changed', true)
          }
        }
      })

      modal.open()
    })
  }

  function _openNewTaskDialog () {
    api.getNewTaskDialogController().then(({ NewTaskDialogController }) => {
      const templateId = 'newTask.html'
      const templateUrl = '/workflow/dialogs/new-task/new-task-dialog.html?$$REVISION$$'
      const controller = NewTaskDialogController

      api._openDialog(templateId, templateUrl, controller, true)
    })
  }
}

export { TaskStatusCardController }
